import React from 'react';
import { alpha, styled } from '@mui/material';
import SimpleBar from 'simplebar-react';
import PropTypes from 'prop-types';
const StyledScrollBar = styled(SimpleBar)(({ theme }) => ({
    height: '100%',
    maxHeight: '100%',
    '& .simplebar-scrollbar': {
        '&:before': {
            backgroundColor: alpha(theme.palette.grey[400], 0.6),
        },
        '&.simplebar-visible:before': {
            opacity: 1,
        },
    },
    '& .simplebar-track.simplebar-vertical': {
        width: 9,
    },
    '& .simplebar-track.simplebar-horizontal .simplebar-scrollbar': {
        height: 6,
    },
    '& .simplebar-mask': {
        zIndex: 'inherit',
    },
    '& .simplebar-placeholder': {
        display: 'none',
    },
})); // props type

const Scrollbar = ({ children, style, sx, ...props }) => {
    return (
        <StyledScrollBar style={style} sx={sx} {...props}>
            {children}
        </StyledScrollBar>
    );
};
Scrollbar.propTypes = {
    children: PropTypes.any,
    style: PropTypes.any,
    sx: PropTypes.any,
};
export default Scrollbar;
